import type { Component } from 'vue'

import { onScopeDispose } from 'vue'

import type {
  ModalActivations,
  ModalConfig,
  ModalEntry,
  ModalRegistration,
  StoredRegistration,
} from '~/composables/modalIsolated'

export const useModal = () => {
  const activeModals = useState<ModalEntry[]>('modal-manager-stack', () => [])
  const registrations = useState<StoredRegistration[]>('modal-manager-registrations', () => [])
  const activations = useState<ModalActivations>('modal-manager-activations', () => ({}))
  const { currentRoute } = useRouter()

  const manager = useModalIsolated(activeModals, registrations, activations)

  const openModal = <C extends Component>(config: ModalConfig<C>) =>
    manager.openModal({ ...config, routePath: currentRoute.value.path })

  const registerModal = <C extends Component>(registration: ModalRegistration<C>) => {
    if (import.meta.server) return { close: () => {}, id: registration.id ?? '' }

    const { id, unregister } = manager.registerModal(registration)
    onScopeDispose(unregister)

    return { close: unregister, id }
  }

  return { ...manager, openModal, registerModal }
}
